import request from "@/util/http";
/**
 * 列表
 */
export function list(pageNumber) {
	return request({
		url: '/goods/shop/brand/list/' + pageNumber,
		method: 'get'
	})
}

/**
 * 详情
 */
export function detail(id) {
	return request({
		url: '/goods/shop/brand/detail/' + id,
		method: 'get'
	})
}

// module.exports = {
// 	list,
// 	detail,
// }
